import React from 'react';
import '../styles/v3-pages.css';

function Resume() {
  return (
    <section className="v3-resume" id="resume" data-aos="fade-up" data-aos-duration="1000">
      <div className="v3-resume-eyebrow">[ RESUME · PG 01 / 02 ]</div>
      <h1 className="v3-resume-title">Vijay Kumar Kagupati.</h1>
      <div className="v3-resume-subline">[ XR DEVELOPER · UNITY · INDIA ]</div>

      <a href="/resume.pdf" download className="v3-resume-download-cta">
        ↓ DOWNLOAD PDF
      </a>

      <iframe
        src="/resume.pdf#toolbar=0"
        style={{ width: '100%', height: '900px', border: '1px solid var(--hair)' }}
        title="Resume PDF"
        className="v3-resume-pdf-embed"
      />

      <div className="v3-resume-section">
        <div className="v3-resume-section-header">[ EXPERIENCE ]</div>
        <div className="v3-resume-section-content">
          <div className="v3-resume-entry">
            <div className="v3-resume-entry-title">Junior Unity Developer</div>
            <div className="v3-resume-entry-subtitle">DJ XLabs, Delhi NCR, India - Nov 2025 - Present</div>
            <div className="v3-resume-entry-body">
              Built Meta Quest spatial museum, MR multiplayer, and stylus painting experiences using Unity, SQLite, REST APIs, Unity Netcode, GPU compute shader UV painting, and event-driven XR architecture. Delivered XR features across 19+ projects for 9 clients in 6 months.
            </div>
          </div>
          <div className="v3-resume-entry">
            <div className="v3-resume-entry-title">Unity Developer Intern</div>
            <div className="v3-resume-entry-subtitle">DJ XLabs, Delhi NCR, India - 2025 - Nov 2025</div>
            <div className="v3-resume-entry-body">
              Engineered end-to-end production of a VR video game for Quest 3, deployed at global tech event in Dubai. Automated workflows by 95% using custom Unity Editor Scripts and implemented multi-language support with RTL text rendering.
            </div>
          </div>
          <div className="v3-resume-entry">
            <div className="v3-resume-entry-title">VR Developer Intern</div>
            <div className="v3-resume-entry-subtitle">CXR, GITAM · 2024 – 2025</div>
            <div className="v3-resume-entry-body">
              Developed virtual reality aircraft simulation utilizing Unity 3D URP and XR Interaction Toolkit. Created interactive mechanisms and lighting effects for Oculus Quest 2. Built project management system using Notion, increasing team productivity by 25%.
            </div>
          </div>
          <div className="v3-resume-entry">
            <div className="v3-resume-entry-title">Vice President Outreach</div>
            <div className="v3-resume-entry-subtitle">Entrepreneurs Club, GITAM · 2024 – 2025</div>
            <div className="v3-resume-entry-body">
              Orchestrated 35+ high-impact events engaging 2000+ students. Organized and moderated 20+ speaker sessions with industry professionals. Initiated outreach campaigns to local schools, inspiring 200+ students to pursue entrepreneurship.
            </div>
          </div>
        </div>
      </div>

      <div className="v3-resume-section">
        <div className="v3-resume-section-header">[ EDUCATION ]</div>
        <div className="v3-resume-section-content">
          <div className="v3-resume-entry">
            <div className="v3-resume-entry-title">Bachelor of Technology in Computer Science</div>
            <div className="v3-resume-entry-subtitle">GITAM, Visakhapatnam · Expected 2025</div>
          </div>
          <div className="v3-resume-entry">
            <div className="v3-resume-entry-title">XR Foundations & Prototyping Bootcamp</div>
            <div className="v3-resume-entry-subtitle">Specialized XR developer training · 2025</div>
          </div>
        </div>
      </div>

      <div className="v3-resume-section">
        <div className="v3-resume-section-header">[ SKILLS ]</div>
        <div className="v3-resume-section-content">
          <div className="v3-resume-entry">
            <div className="v3-resume-entry-title">XR Development</div>
            <div className="v3-resume-entry-body">
              Unity 3D · URP · XR Interaction Toolkit · Oculus Quest 2/3 · Android XR
            </div>
          </div>
          <div className="v3-resume-entry">
            <div className="v3-resume-entry-title">Programming</div>
            <div className="v3-resume-entry-body">
              C# · C++ · Python · JavaScript · HTML/CSS
            </div>
          </div>
          <div className="v3-resume-entry">
            <div className="v3-resume-entry-title">Tools & Technologies</div>
            <div className="v3-resume-entry-body">
              Git · Notion · Blender · Visual Studio · VS Code · RTL-TMPro
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Resume;
